import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import vision from "../assets/icons/vision.png";
import mission from "../assets/icons/mission.png";
import values from "../assets/icons/values.png";
import "../style/VisionMissionValues.css";

const VisionMissionValues = () => {
  useEffect(() => {
      AOS.init();
    }, [])
  return (
    <div className="container">
      <h2 className="title">
        OUR <span className="highlight">PHILOSOPHY</span>
      </h2>
      <div className="sections">
        <div className="section" data-aos="fade-up" data-aos-duration="1000">
          <img src={vision} alt="Vision" className="icon" />
          <h2>Vision</h2>
          <p className="highlighted">
            To deliver quality steel detailing services on time, at a fair
            price, ensuring exceptional value without compromise.
          </p>
        </div>
        <div className="section" data-aos="fade-up" data-aos-duration="1000">
          <img src={mission} alt="Mission" className="icon" />
          <h2>Mission</h2>
          <p>
            Quality at fair price will always be less expensive than mediocrity
            at a lower price.
          </p>
        </div>
        <div className="section" data-aos="fade-up" data-aos-duration="1000">
          <img src={values} alt="Values" className="icon" />
          <h2>Values</h2>
          <p>
            We believe in <b>QUALITY SCHEDULE & GOOD COMMUNICATION</b> to build
            healthy customer relationships based on trust and transparency.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VisionMissionValues;
